import * as React from "react";
import { WizardLXPWAProps } from "./typings";
import { inject, observer } from "mobx-react";
import { WizardLXPWAView } from "./WizardLXPWAView";

@inject("wizardState")
@observer
export class WizardLXPWA extends React.Component<WizardLXPWAProps> {
  constructor(props: WizardLXPWAProps) {
    super(props);
    const { lxWizardState } = this.props.wizardState;
    const { location } = this.props.context.searchContext;
    const { placeholderDestination: setDefaultDestination = true } = this.props.flexComponent.model;
    const { visibleLobSubtitle } = this.props.flexComponent.model;

    lxWizardState.overrideConfig(() => {
      lxWizardState.config.elementId = this.props.flexComponent.id;
      lxWizardState.config.heading.fixedTitle = this.props.flexComponent.model.fixedLobTitle;
      lxWizardState.config.lastSearch.useLastSearchForSingleLOB = this.props.flexComponent.model.useLastSearchForSingleLOB;
      lxWizardState.config.heading.lobSubtitleBreakPoint = this.props.flexComponent.model.lobSubtitleBreakPoint;
      lxWizardState.config.heading.hideLobTitle = this.props.flexComponent.model.hideLobTitle;
      lxWizardState.config.heading.visibleLobSubtitle =
        visibleLobSubtitle ?? lxWizardState.config.heading.visibleLobSubtitle;
    });

    if (location != null && setDefaultDestination) {
      lxWizardState.setDefaultDestination(
        location.extendedName,
        location.id,
        location.parent?.code || "",
        location.code,
        "",
        ""
      );
    }

    lxWizardState.updateStateFromCookie();
    lxWizardState.updateDateFromConfig();
  }

  public render() {
    return <WizardLXPWAView {...this.props} />;
  }
}

export default WizardLXPWA;
